import { getLiteral } from 'utils/getLiteral';

const CHECK_ICON_SVG = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="16" height="16" aria-hidden="true"><path d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0Zm3.78 5.22a.75.75 0 0 1 0 1.06l-4.25 4.25a.75.75 0 0 1-1.06 0L4.22 8.28a.75.75 0 0 1 1.06-1.06L7 9.94l3.72-3.72a.75.75 0 0 1 1.06 0Z"/></svg>`;

const DASH_ICON_SVG = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="16" height="16" aria-hidden="true"><path d="M4 7.25h8"/></svg>`;

const STATUS_ICON_CELL_PARAMS = {
    align: 'center',
    otherFields: {
        icons: {
            true: { svg: CHECK_ICON_SVG },
            false: { svg: DASH_ICON_SVG },
        },
    },
};

const BLACKLIST_AUTO_HEIGHT_ROW_LIMIT = 8;

export function getBlackListSectionListLayout(rowCount = 0) {
    if (rowCount <= BLACKLIST_AUTO_HEIGHT_ROW_LIMIT) {
        return {
            domLayout: 'autoHeight',
            classNameModifier: 'mailchimp-blacklist-section-list--auto-height',
        };
    }

    return {
        domLayout: 'normal',
        classNameModifier: 'mailchimp-blacklist-section-list--scrollable',
    };
}

export function mapBlackListRows(blackListData = []) {
    return blackListData.map((email, index) => ({
        id: email.email || `blacklist-${index}`,
        email: email.email || '',
        unsubscribed: email.statusId === 1,
        invalidEmail: email.statusId !== 1,
    }));
}

export function getBlackListColumnDefs() {
    return [
        {
            colId: 'email',
            field: 'email',
            headerName: getLiteral('label_mailchimp_email'),
            headerComponent: 'headerTextCell',
            cellRenderer: 'textCell',
            flex: 1,
            minWidth: 220,
        },
        {
            colId: 'unsubscribed',
            field: 'unsubscribed',
            headerName: getLiteral('label_mailchimp_unsubscribed'),
            headerComponent: 'headerTextCell',
            cellRenderer: 'iconCell',
            width: 160,
            resizable: false,
            cellRendererParams: STATUS_ICON_CELL_PARAMS,
        },
        {
            colId: 'invalidEmail',
            field: 'invalidEmail',
            headerName: getLiteral('label_invalid_email'),
            headerComponent: 'headerTextCell',
            cellRenderer: 'iconCell',
            width: 160,
            resizable: false,
            cellRendererParams: STATUS_ICON_CELL_PARAMS,
        },
    ];
}
